export default "__VITE_ASSET__DdMcdg0G__"